import { useRef } from 'react'
import { Bot, Plus } from 'lucide-react'
import { Button } from '@anyemp/ui-kit'
import { useAuth } from '../../hooks/useAuth'
import AISettingsTab from './AISettingsTab'
import SectionBlock from '../UI/SectionBlock'
import SectionHeader from '../UI/SectionHeader'

const AISettingsSection = ({ talentId, talentType }) => {
  const aiRef = useRef(null)
  const { hasPermission } = useAuth()

  const canCreate = hasPermission('talent-service', `${talentType}_ai_settings`, 'create')

  const headerAction = canCreate ? (
    <Button size="small" onClick={() => aiRef.current?.openForm()}>
      <Plus className="h-3.5 w-3.5" />Add
    </Button>
  ) : null

  return (
    <SectionBlock id="ai-settings">
      <SectionHeader icon={Bot} title="AI Settings" action={headerAction} />
      <AISettingsTab
        ref={aiRef}
        talentId={talentId}
        talentType={talentType}
        showAddButton={false}
      />
    </SectionBlock>
  )
}

export default AISettingsSection
